import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=19197735&"
import script from "./ParticipantList.vue?vue&type=script&lang=js&"
export * from "./ParticipantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports